import ProjectImg1 from '../../images/work/nuru1.png';
import ProjectImg2 from '../../images/work/nuru2.png';
import ProjectImg3 from '../../images/work/looqu1.png';
import ProjectImg4 from '../../images/work/looqu3.png';
import ProjectImg5 from '../../images/work/compassionate1.png';
import ProjectImg6 from '../../images/work/compassionate2.png';
import ProjectImg7 from '../../images/work/ko1.png';
import ProjectImg8 from '../../images/work/ko1.png';
import ProjectImg9 from '../../images/work/robo2.png';
import ProjectImg10 from '../../images/work/robo1.png';

export const projects = [
  {
    id: 1,
    photoBig: ProjectImg1,
    github: 'https://github.com/KevinOchiengg/nuru-palace-hotel',
    projectLink: 'http://nurupalacehotel.netlify.com/',
    photoSmall: ProjectImg2,
    projectTitle: 'Nuru Palace Hotel',
    projectDetails:
      'Nuru Palace is a holiday letting company, based in Nakuru, Kenya.They had  this outdated, unresponsive and visually not appealing website, which resulted to a bad user experience, particularly on mobile devices.The company therefore needed a fresh of their website and an updated website that was responsive and easy to use, which I was able to put in place.',
    service: 'Web maintanance',
  },
  {
    id: 2,
    photoBig: ProjectImg3,
    github: 'https://github.com/KevinOchiengg/compassionatelove-website',
    projectLink: 'https://compassionatelove.netlify.app/',
    photoSmall: ProjectImg4,
    projectTitle: 'Looqu store',
    projectDetails:
      'Looqu store  is a fully functional E-commerce website. The business had a challenge of reaching out to a wide range of customers because its online presence was limited. An opportunity presented it self and I grabbed it, by helping the client to formulate a more manageable website.',
    service: 'Web development',
  },

  {
    id: 3,
    photoBig: ProjectImg5,
    github: 'https://github.com/KevinOchiengg/nuru-palace-hotel',
    projectLink: 'http://nurupalacehotel.netlify.com/',
    photoSmall: ProjectImg6,
    projectTitle: 'Compassionate',
    projectDetails:
      'Compassionate Love is a christian charity organization, based in Kenya. The organization had no website to spread their word and  work. Being able to bring forth expertise in design, installation, testing and maintenance of web systems, I was able to create a   website for the organization.',
    service: 'Web development',
  },
  {
    id: 4,
    photoBig: ProjectImg7,
    github: 'https://github.com/KevinOchiengg/nuru-palace-hotel',
    projectLink: 'http://nurupalacehotel.netlify.com/',
    photoSmall: ProjectImg8,
    projectTitle: 'K&O Technologies',
    projectDetails:
      'This is my portfolio website where I am able to showcase and bring forth expertise in design, installation, testing and maintenance of web systems. You might be tempted to ask, "why a portfolio as one of his projects?" Well, as a web developer, I believe in problem solving. This portfolio helps me connect with my clients and my fellow developers, to which I am able to learn and grow my ideas from.',
    service: 'Web development',
  },
  {
    id: 5,
    photoBig: ProjectImg9,
    github: 'https://github.com/KevinOchiengg/ko-portfolio-app',
    projectLink: 'https://ko-technologies.netlify.com/',
    photoSmall: ProjectImg10,
    projectTitle: 'Face Recognition App',
    projectDetails:
      'This a face recognition application built in react. You can paste your image url, and the app will do the magic of detecting a face in your image. Creating this project helped me master react, APIs and most full stack web development.',
  },
];
